import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialog, MatDialogConfig } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { SelectionModel } from '@angular/cdk/collections';
import { PanelService } from 'src/app/shared/panel-service/panel.service';
import { ActivatedRoute } from '@angular/router';
import { CandidateDetailsModalComponent } from './candidate-details-modal/candidate-details-modal.component';
import { FeedbackModalComponent } from './feedback-modal/feedback-modal.component';
import { Panel } from 'src/app/model/panel-modal/panel-model';
import { PanelAsignService } from 'src/app/shared/panel-assign/panel-assign.service';
import { ApiService } from 'src/app/shared/api.service';
import { Process } from 'src/app/model/process-model/process.model';
import { ProcessService } from 'src/app/shared/process-service/process.service';
import { NotificationService } from 'src/app/shared/notification.service';
import { DialogService } from 'src/app/shared/dialog-service/dialog.service';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-panel-assigning',
  templateUrl: './panel-assigning.component.html',
  styleUrls: ['./panel-assigning.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PanelAssigningComponent implements OnInit {

  private eventId = this.apiService.getEventId();
  eventName: string;
  meetingLink: string;
  panelName: string;
  roomNo: string;
  createdDate: Date;
  feedback: string;
  statusMap = new Map();
  feedBackMap = new Map();
  attdenceMap = new Map();
  panelId: string;
  sessionId: String;
  panelDetails: Panel[];

  public process: Process;
  processName: string;
  processStartDate: string;
  processEndDate: string;
  allProcesses: Process[];

  status: '3' | '2' = '2';

  panelMemberListData: MatTableDataSource<any>;
  candidateListData: MatTableDataSource<any>;
  displayedColumns1: string[] = ['position', 'fullName'];
  displayedColumns2: string[] = ['position', 'select', 'updateAttendance', 'candidateName', 'candidateDetails', 'status', 'feedback', 'action'];

  panelAssign: any;
  assignedCandidate = [];
  currentCandidateId: number;

  attendanceJsonObject = {};
  statusJsonObject = {};

  showHideLogicAttdenceButton: boolean;
  confirmMsg = "Please re-check all the details you have given before submitting, If checked then hit Yes otherwise hit No";

  constructor(
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private processService: ProcessService,
    private panelService: PanelService,
    private dialog: MatDialog,
    private panelAssignService: PanelAsignService,
    private notificationService: NotificationService,
    private dialogService: DialogService,
    private activatedRoute: ActivatedRoute,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer) {
    // this.panelId = this.activatedRoute.snapshot.paramMap.get('id');
    iconRegistry.addSvgIcon(
      'copy-to-clipboard',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/copy-to-clipboard.svg'));
    iconRegistry.addSvgIcon(
      'open-meeting-in-new-tab',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/duo_black_24dp.svg'));
    this.sessionId = this.activatedRoute.snapshot.queryParamMap.get('sessionId');
  }
  /** for Check Box Selection in a table */
  selection = new SelectionModel<any>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this.candidateListData != null) {
      const numSelected = this.selection.selected.length;
      const numRows = this.candidateListData.data.length;
      return numSelected === numRows;
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.candidateListData.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?, onloadAttendence?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    if (onloadAttendence == 1) {
      let attdence = `${this.selection.isSelected(row) ? '0' : '1'}`
      this.attdenceMap.set(row.candidateId, attdence);
    } else {
      let attdence = `${this.selection.isSelected(row) ? '1' : '0'}`
      this.attdenceMap.set(row.candidateId, attdence);
    }
    // console.log(this.attdenceMap);
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }


  atttenceCheck(row?): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    let attdence = `${this.selection.isSelected(row) ? '0' : '1'}`
    this.attdenceMap.set(row.candidateId, attdence);
    console.log(this.attdenceMap);
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
    if (!this.sessionId) {
      this.notificationService.warn("Access Denied");
      ApiService.sessionExpireRedirection();
    } else {
      this.panelAssignService.verifyPanelMemberSession(this.sessionId)
        .then(response => {
          if (response && typeof response === 'object') {
            const {
              sessionId,
              eventId,
              panelMemberId,
              role,
              panelId,
              userEmail
            } = response;

            this.apiService.setSessionObject({
              eventId,
              sessionId,
              panelMemberId,
              role,
              email: userEmail,
              panelId
            })

            this.panelId = panelId;
            if (this.panelId) {
              this.getPanelById();
            }
          }
        })
        .catch(error => {
          this.notificationService.warn((
            error &&
            error.errors &&
            error.errors[0] &&
            error.errors[0].message) ||
            "Access Denied");
          ApiService.sessionExpireRedirection();
        })
    }
    // setTimeout("location.reload(true);", 300000);
  }

  getAllProcess(processId) {
    this.processService.findAll().then(
      processes => {
        this.allProcesses = processes;
        if (processes != null) {
          for (let i = 0; i < processes.length; i++) {
            if (processes[i].processId === processId) {
              this.process = this.allProcesses[i];
              this.processName = this.process.processName;
              this.processStartDate = this.process.startDate;
              this.processEndDate = this.process.endDate;
              // console.log("current process " + processes[i].processName);
            }
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  getPanelById() {
    this.panelService.findById(this.panelId).then(
      panelDetails => {
        this.setMapForpanelCandidates(panelDetails.panelCandidates);
        this.eventName = panelDetails.eventName;
        this.panelName = panelDetails.panelName;
        this.roomNo = panelDetails.roomNo;
        this.meetingLink = panelDetails.meetingLink;
        this.candidateListData = new MatTableDataSource(panelDetails.panelCandidates);
        this.panelMemberListData = new MatTableDataSource(panelDetails.panelPanelMembers);
        this.candidateListData.sort = this.sort;
        if (panelDetails.selectedCnt + panelDetails.rejectedCnt == panelDetails.assignedCnt) {  // 
          this.showHideLogicAttdenceButton = false;
        } else {
          this.showHideLogicAttdenceButton = true;
        }
        this.getAllProcess(panelDetails.processId);
        // console.log(panelDetails);
      },
      err => {
        console.log(err);
      }
    );
  }
  setMapForpanelCandidates(panelCandidates) {
    for (let i = 0; i < panelCandidates.length; i++) {
      if (panelCandidates[i].status == 2 || panelCandidates[i].status == 3) {
        this.statusMap.set(panelCandidates[i].candidateId, panelCandidates[i].status);
        this.feedBackMap.set(panelCandidates[i].candidateId, panelCandidates[i].feedback);
      }
      if (panelCandidates[i].attendance != null) {
        this.attdenceMap.set(panelCandidates[i].candidateId, panelCandidates[i].attendance);
      } else {
        this.attdenceMap.set(panelCandidates[i].candidateId, 0);
      }
    }
  }

  candidateAttendance() {
    console.log(this.selection.selected);
    let presentCandidateIds = [];
    let absentCandidateIds = [];
    for (let [key, value] of this.attdenceMap) {
      console.log(key + "" + value);
      if (value == 1) {
        presentCandidateIds.push(key);
      } else {
        absentCandidateIds.push(key);
      }
    }
    // let jsonObject = {};
    this.attendanceJsonObject['presentCandidateIds'] = presentCandidateIds;
    this.attendanceJsonObject['absentCandidateIds'] = absentCandidateIds;
    this.panelAssignService.updateAttendance(this.attendanceJsonObject, this.panelId).then(
      response => {
        this.notificationService.success('Successfully updated attendance');
        this.getPanelById();
        // console.log(response); 
      },
      err => {
        this.notificationService.warn("Failed to update");
        // console.log(err);
      }
    );
    // window.location.reload();
  }

  openDetails(candidateId) {
    const dialogRef = this.dialog.open(CandidateDetailsModalComponent, {
      width: '70%',
      autoFocus: true,
      disableClose: true,
      data: { candidateId: candidateId, processName: this.processName }
    });
  }

  openFeedback(candidateId) {
    if (this.attdenceMap.get(candidateId) === null || typeof this.attdenceMap.get(candidateId) === "undefined" || this.attdenceMap.get(candidateId) === "") {
      alert("Attendance is missing, attendance is required to give feedBack, Please update the attendance!!");
      return;
    }
    this.currentCandidateId = candidateId;
    const dialogRef = this.dialog.open(FeedbackModalComponent, {
      width: '30%',
      autoFocus: true,
      disableClose: true,
      data: { feedback: this.feedback, candidateId: candidateId, panelId: this.panelId, status: this.statusMap.get(candidateId) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.feedBackMap.set(candidateId, this.feedback = result.data);
    });
  }

  statusChanged($event, candidateId) {
    this.statusMap.set(candidateId, $event.value);
    let candidateIdArray = [];
    candidateIdArray.push(candidateId);
    // let jsonObject = {};
    this.statusJsonObject['candidateIds'] = candidateIdArray;
    this.statusJsonObject['status'] = $event.value;
    this.spinner.show();
    this.panelAssignService.updateStatus(this.statusJsonObject, this.panelId).then(
      // updateStatus => {
      //   this.spinner.hide();
      // },
      response => {
        this.spinner.hide();
      },
      err => {
        console.log(err);
      }
    );
  }
  async updateCandidate(candidateId) {
    let errorMsg = "";
    if (this.statusMap.get(candidateId) === null || typeof this.statusMap.get(candidateId) === "undefined" || this.statusMap.get(candidateId) === "") {
      errorMsg = errorMsg + "1 - Status is missing, status should be selected or rejected for this candidate !!";
    }
    if (errorMsg != "") {
      alert(errorMsg);
      return;
    }

    this.dialogService.openConfirmDialog(this.confirmMsg).afterClosed().subscribe(res => {
      if (res) {
        this.spinner.show();
        let candidateIdArray = [];
        candidateIdArray.push(candidateId);
        let jsonObject = {};
        jsonObject['candidateIds'] = candidateIdArray;
        this.panelAssignService.completeFeedback(jsonObject, this.panelId).then(
          async updateStatus => {
            await this.getPanelById();
            this.spinner.hide();
          },
          err => {
            console.log(err);
          }
        );
        this.notificationService.success('Status & Feedback Updated Successfully');
      }
    });
  }


  /**for panelCompletion Checkbox */
  selection1 = new SelectionModel<any>(true, []);
  isAllSelected1() {
    const numSelected = this.selection1.selected.length;
    const numRows = this.candidateListData.data.length;
    return numSelected === numRows;
  }
  masterToggle1() {
    this.isAllSelected1() ?
      this.selection1.clear() :
      this.candidateListData.data.forEach(row => this.selection1.select(row));
  }

  panelCompletion() {
    console.log(this.selection1.selected);
    this.dialogService.openConfirmDialog(this.confirmMsg).afterClosed().subscribe(res => {
      if (res) {
        let candidateIdArray = [];
        candidateIdArray.push(this.selection1.selected);
        let jsonObject = {};
        jsonObject['candidateIds'] = candidateIdArray;
        this.panelAssignService.completeFeedback(jsonObject, this.panelId);
        window.location.reload();
        this.notificationService.success('Status & Feedback Updated Successfully');
      }
    });
    window.location.reload();
  }
  
  copyToClipboard(text: string) {
    const selBox = document.createElement('textarea');

    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = text;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox); 

    this.notificationService.success("Copied to clipboard");
  }

  openInNewTab(link: string) {
    window.open(link, '_blank');
  }

}